<template>
  <div class="super_container">
    <HeaderView/>
    <div class="webcontent">
      <router-view/>
    </div>
    <FooterView/>
  </div>
</template>

<script>
import HeaderView from './components/HeaderView.vue';
import FooterView from './components/FooterView.vue';
export default {
  name: 'App',
  components:{HeaderView, FooterView},
}
</script>

<style>
@import url("./assets/css/main_styles.css");
@import url("./assets/css/responsive.css");
.webcontent{padding-top: var(--header-height); padding-top: calc(var(--header-height) + var(--top-bar-height))}

</style>
